export enum MDSNotePreviewContainerVariant {
  Standard = "standard",
  Flat = "flat",
}

export interface MDSNotePreviewContainerProps extends React.PropsWithChildren {
  /**
   * The title to display in the footer.
   */
  title: string;

  /**
   * The creation date of the note (ISO string or Date).
   */
  createdAt: string | Date;

  /**
   * The modification date of the note (ISO string or Date).
   * If not provided or same as createdAt, only creation date will be shown.
   */
  modifiedAt?: string | Date;

  /**
   * Array of author names.
   */
  authorNames: string[];

  /**
   * Secondary label to display in the footer.
   */
  secondaryLabel?: string | null;

  /**
   * If true, only shows creation date (no modification date).
   */
  updateOnly?: boolean;

  /**
   * Width of the preview container. Defaults to "400px".
   * Can be any valid CSS width value (e.g., "300px", "100%", "20rem").
   */
  width?: string;

  /**
   * Additional CSS class name for the container.
   */
  className?: string;

  /**
   * Variant of the preview container.
   */
  variant?: MDSNotePreviewContainerVariant;

  /**
   * Callback function to handle click events on the container.
   */
  onClick?: React.MouseEventHandler<HTMLDivElement>;

  /**
   * If true, scrolls to the top of the container.
   */
  shouldScroll?: boolean;
}
